import type {
  OrderGetResponseType,
  OrderShippingRequestItemType,
} from "@sellar-io/api-v2/types";
import { useState } from "react";
import { Icon, H5, H6 } from "@sellar-io/components";
import { OrderRemoveBoxModal } from "./OrderRemoveBoxModal";

export const OrderCreateConsignmentBoxItem = ({
  box,
  items,
  onRemove,
}: {
  index: number;
  box: OrderShippingRequestItemType;
  items: (OrderGetResponseType["OrderItems"][number] & { itemId: number })[];
  onRemove: () => void;
}) => {
  const [active, setActive] = useState<boolean>(false);

  const remove = () => {
    setActive(false);
    onRemove();
  };

  return (
    <>
      <div className="mb-4 flex flex-row justify-between">
        <div className="flex flex-col">
          <H5>
            1x label ({box.weight}
            kg)
          </H5>
          <H6>Contains:</H6>
          <div className="flex flex-col">
            {box.OrderItemIds.map((id) => (
              <H6 key={id}>
                {items.find((item) => item.itemId === id)?.Product.name}
              </H6>
            ))}
          </div>
        </div>
        <Icon
          className={"cursor-pointer"}
          onClick={() => setActive(true)}
          icon={"PENCIL"}
        />
      </div>
      <OrderRemoveBoxModal
        active={active}
        onDismiss={() => setActive(false)}
        onDelete={remove}
      />
    </>
  );
};
